import { createSlice } from '@reduxjs/toolkit';

const favSlice = createSlice({
  name: 'fav',
  initialState: {
    products: [],
    quantity: 0,
    total: 0,
  },

  reducers: {
    addFavorite: (state, action) => {
      const existingIndex = state.products.findIndex((item) => item._id === action.payload._id);

      if (state.products[existingIndex]) {
        state.products = state.products.filter((product) => product._id !== action.payload._id);
        if (state.products.length >= 0) {
          state.quantity -= 1;
        }
      } else {
        state.quantity += 1;
        state.products.push(action.payload);
      }
    },
  },
});

export const { addFavorite, removeFavourite } = favSlice.actions;
export default favSlice.reducer;
